up.macro('#query_diet', (element) => {

  element.removeAttribute('onclick')
  up.on(element, 'click', () => { up.element.remove(element) })

})
